<!-- 机房控制 -->
<template>
    <div class='topology-box'>
        <!-- 机房控制 -->
        <div id="topology-body" style="height:100%;width:100%;padding:15px;box-sizing: border-box;">
            <canvas class="topology-context" style="background: rgb(193, 215, 229);" id="topology-canvas"></canvas>
            <div class="option-box" style="">
                <el-button size="mini" @click="handleSetOpt('showInCenter')">居中</el-button>
                <el-button size="mini" @click="handleFullScreen">{{fullscreen?`取消全屏`:`全屏`}}</el-button>
                <template v-if="user.usertype<=3">
                    <el-button type="primary" size="mini" @click="handleAdd">监控设置</el-button>
                    <el-button type="primary" v-show="oid != ''" size="mini" @click="handleMobileSet">移动端设置</el-button>
                    <el-button type="primary" v-show="oid != ''" size="mini" @click="handlePumpSet">水泵参数设置</el-button>
                </template>
            </div>
            <div class="tip-box" v-if="collectorOnline || meterOnline">
                <span class="blink">通讯中断...</span>
            </div>

            <!-- <div class="option-fullScreen" @click="handleFullScreen">
                <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                    <i class="el-icon-rank" style="font-size: 24px;"></i>
                </el-tooltip>
            </div> -->

            <!-- 弹出层 -->
            <el-dialog :title="nodeTitle" :visible.sync="dialogFormVisible" width="450px">
                <template v-for="(v, i) in node_relevanceVar">
                    <el-row :gutter="20" :key="i" style="margin-bottom:10px;">
                        <el-col :span="12">
                            {{v.var_name}}
                        </el-col>
                        <el-col :span="12">
                            {{v.var_des}}
                        </el-col>
                    </el-row>
                </template>
                <div style="height:10px;width:100%;"></div>
                <el-row :gutter="20" style="text-align:center;">
                    <el-col :span="12">
                    <el-button type="danger" size="small" :disabled="disabled" @click="handleStop(0)">停止</el-button>
                    </el-col>
                    <el-col :span="12">
                    <el-button type="primary" size="small" :disabled="disabled" @click="handleStop(1)">启动</el-button>
                    </el-col>
                </el-row>
            </el-dialog>

            <!-- 系统控制弹框 -->
            <el-dialog :title="nodeSysTitle" :visible.sync="dialogSysVisible" width="450px">
                <el-row :gutter="20" style="text-align:center;">
                    <el-col :span="12">
                    <el-button type="danger" size="small" @click="handleSysStop(0)">停止</el-button>
                    </el-col>
                    <el-col :span="12">
                    <el-button type="primary" size="small" @click="handleSysStop(1)">启动</el-button>
                    </el-col>
                </el-row>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Machine_Editor from '../machineset'
import Service from '@/api/Service'
import { computedUtil1 } from '@/utils/utils.js'

var Timer = {};
var DashTimer = {};
export default {
    name:  'monitoringmanna',
    data() {
        return {
            oid: '',    //  项目id
            terminalid: '',     //  表计OID

            // 弹框
            dialogFormVisible: false,
            nodeTitle: '',
            node_relevanceVar: [],
            optVar: {},

            nodeSysTitle: '',
            dialogSysVisible: false,
            sysOptVar: {},
            sysStatusVar: {},

            // 变量列表
            varData: [],
            // 存储节点变量控制
            nodeVarList: [],

            ws_data: {},
            disabled: false,        //  0点动可以控制设备，1自动不能控制设备

            fullscreen: false,
            
            collectorOnline: false,
            meterOnline: false,
        };
    },

    computed: {
        // 项目信息
        ...mapGetters(["WS", "ws_terminalReading", "user", "projectInfo", "machine",'projectsystemInfo']),
    },
    watch: {
        // 监听socket数据
        ws_terminalReading: {
            handler(newVal,oldVal){
                //code...业务逻辑
                this.handleData(newVal);
            },
            immidiate:true,
            deep:true,
        }
    },
    async created() {
        this.$store.dispatch("GetProjectSystemInfo");
		this.$store.dispatch("GetProjectInfo");
        await this.getData();
        await this.getList();
    },
    mounted() {
        let _t = this;
        this.$nextTick(()=>{
            let canvas = document.getElementById('topology-canvas')
            if(canvas) {
                canvas.width = $('#topology-body').width();
                canvas.height = $('#topology-body').height();
            }
            // 单击
            Machine_Editor.handlerClick = function(target) {
                try {
                    if(target.nodeType === 'BUTTON') {
                        // 系统控制
                        _t.handleControlSys(target);
                        return
                    }
                    _t.handlerOpen(target)
                } catch (error) {
                    console.log("节点参数有误")
                }
            };
            // 双击节点
            Machine_Editor.handlerdbClick = function(target) {
                console.log(target);
            };
            // setTimeout(() => {
            //     DashTimer = Machine_Editor.LineDash({x: 10, y: 100}, {x: 400,y:100}, false)
            // }, 5000);
        })
    },
    destroyed() {
        // 关闭设备监控
        this.wsSendData("21", "[]");
        for (const key in Timer) {
            if (Timer.hasOwnProperty(key)) {
                const id = Timer[key];
                window.clearInterval(id)
            }
        }
    },
    methods: {
        getData: async function(data) {
            // 获取机房监控
            let res = await Service.getServerroombypid();
            if(res !== 'success') {
                let childs = JSON.parse(res[0].map_value_computer);
                this.oid = res[0].oid;
                let nodeVar = []
                if(childs && childs.childs && childs.childs[0].childs) {
                childs.childs[0].childs.map(v2=>{
                    // 存储nodeId+节点参数
                    nodeVar.push({
                        nodeId: v2.nodeId,
                        nodeParams: v2.nodeParams,
                    })
                    v2.dragable = false;    //  不允许拖动
                    v2.showSelected = false
                })
                this.nodeVarList = JSON.parse(JSON.stringify(nodeVar));
                Machine_Editor.init(childs)
                setTimeout(() => {
                    Machine_Editor.utils.showInCenter();
                }, 0);
            }
            }else{
                Machine_Editor.init('-1');
            }
        },
        // 处理实时数据
        handleData(data) {
            if(data.length<=0) {
                console.log("没有设备数据");
                return
            }
            console.log(data);
            let newArr = data.map(v=>{
                let obj = {}
                obj["terminal"] = v.terminal;   // 表计信息
                if(v.data.data === null) {
                    this.meterOnline = true;
                    console.log("设备没有上报数据");
                }else{
                    obj.data = v.data.data;
                    v.data.data.map(v=>{
                        for (let index = 0; index < v.bytes; index++) {
                           let addr = v.addr + index;
                           this.ws_data[addr] = v.data[index];
                        }
                    })
                    this.fmtData()
                }

                this.checkMeterOnline(v.terminal)       //  判断PLC状态
                return obj
            })
        },
        // 遍历node，处理状态
        fmtData() {
            
            let obj = this.ws_data;
            this.nodeVarList.map(v=>{
                if(!v.nodeParams.node_var) return
                let var_addr = v.nodeParams.node_var[0].var_addr;
                let t_Node = Machine_Editor.utils.getNodeByKey('nodeId', v.nodeId);
                // 判断节点类型
                if(v.nodeParams.type === 'ZJ_1') {
                    // 离心主机
                    if(obj[var_addr] == 1) {
                        // 打开
                        t_Node.setImage('/resources/image/n_zuji_on.png');
                    }else {
                        // 关闭
                        t_Node.setImage('/resources/image/n_zuji_off.png');
                    }
                }
                if(v.nodeParams.type === 'ZJ_2') {
                    // 螺杆主机
                    if(obj[var_addr] == 1) {
                        // 打开
                        t_Node.setImage('/resources/image/l_zuji_on.png');
                    }else {
                        // 关闭
                        t_Node.setImage('/resources/image/l_zuji_off.png');
                    }
                }
                // 冷却塔
                if(v.nodeParams.type === 'LQT') {
                    if(obj[var_addr] == 1){
                        function timer() {
                            let Count = 1;
                            let timerId = Timer[var_addr]
                            if(Timer[var_addr]) window.clearInterval(timerId);
                            Timer[var_addr] = setInterval(() => {
                                if(Count>2){
                                    Count = 1;
                                }
                                t_Node.setImage('/resources/image/lengqueta-' + Count + '.png');
                                Count++;
                            }, 200);
                        }
                        timer()
                    }else{
                        if(Timer[var_addr]) window.clearInterval(Timer[var_addr]);
                        t_Node.setImage('/resources/image/lengqueta.png');
                    }
                }
                // 冷却阀
                if(v.nodeParams.type === 'LQF') {
                    if(obj[var_addr] == 1) {
                        // 打开
                        t_Node.setImage('/resources/image/lengquefa-on.png');
                    }else {
                        // 关闭
                        t_Node.setImage('/resources/image/lengquefa-off.png');
                    }
                }
                // 水泵1
                if(v.nodeParams.type === 'SB_1') {
                    if(obj[var_addr] == 1){
                        function timer() {
                            let Count = 1;
                            if(Timer[var_addr]) window.clearInterval(Timer[var_addr]);
                            Timer[var_addr] = setInterval(() => {
                                if(Count>2){
                                    Count = 1;
                                }
                                t_Node.setImage('/resources/image/shuibeng1-' + Count + '.png');
                                Count++;
                            }, 200);
                        }
                        timer()
                    }else{
                        if(Timer[var_addr]) window.clearInterval(Timer[var_addr]);
                        t_Node.setImage('/resources/image/shuibeng1.png');
                    }
                }
                // 水泵2
                if(v.nodeParams.type === 'SB_2') {
                    if(obj[var_addr] == 1){
                        function timer() {
                            let Count = 1;
                            if(Timer[var_addr]) window.clearInterval(Timer[var_addr]);
                            Timer[var_addr] = setInterval(() => {
                                if(Count>2){
                                    Count = 1;
                                }
                                t_Node.setImage('/resources/image/shuibeng2-' + Count + '.png');
                                Count++;
                            }, 200);
                        }
                        timer()
                    }else{
                        if(Timer[var_addr]) window.clearInterval(Timer[var_addr]);
                        t_Node.setImage('/resources/image/shuibeng2.png');
                    }
                }
                // 故障状态
                if(v.nodeParams.type === 'DOT') {
                    if(obj[var_addr] == 1){
                        function timer() {
                            let Count = 1;
                            if(Timer[var_addr]) window.clearInterval(Timer[var_addr]);
                            Timer[var_addr] = setInterval(() => {
                                if(Count>2){
                                    Count = 1;
                                }
                                t_Node.setImage('/resources/image/reddot-' + Count + '.png');
                                Count++;
                            }, 200);
                        }
                        timer()
                    }else{
                        if(Timer[var_addr]) window.clearInterval(Timer[var_addr]);
                        t_Node.setImage('/resources/image/reddot-1.png');
                    }
                }
                if(v.nodeParams.type === "NB" || v.nodeParams.type === "WB") {
                    t_Node = Machine_Editor.utils.getTextNodeByKey('nodeId', v.nodeId);
                    let value = this.varData.filter(v=>{return v.var_Initial_addr == var_addr})
                    
                    if(value.length <=0 || obj[var_addr] === undefined) return
                    if(value[0].var_type == 1) {

                        let unit = computedUtil1(var_addr, value)
                        t_Node.text = (obj[var_addr] * unit).toFixed(2)
                    } else {
                        // bool类型
                        if(obj[var_addr] == 1) {
                            t_Node.text = value[0].var_1_represent
                            t_Node.fontColor = "255,0,0"
                        } else {
                            t_Node.text = value[0].var_0_represent
                            t_Node.fontColor = "38,108,186"
                        }
                    }
                    
                }
                // 系统控制
                if(v.nodeParams.type === 'BUTTON') {
                    if(obj[var_addr] == 1){
                        // 启动
                        t_Node.fillColor = "22,124,255"
                    }else{
                        // 停止
                        t_Node.fillColor = "140,140,140"
                    }
                }
            })

            this.disabled = this.ws_data[2] === 0; //  自动模式1 不能控制
        },
        handleAdd() {
            let projectId = this.projectInfo.oid;
            let url
            if(this.oid === '') {
                url = `/resources/topoEditor.html?projectId=${projectId}`
            }else{
                let oid = this.oid;
                url = `/resources/topoEditor.html?projectId=${projectId}&id=${oid}`
            }
            window.open(url)
        },
        handleMobileSet(){
            let oid = this.oid || 0;
            this.$router.push("/machinemana/mobile/" + oid)  
        },

        handlePumpSet() {
            this.$router.push("/pumpsetting/pumpsetting")  
        },

        // 获取var变量管理
        // 获取集控器列表
        async getList() {
            
            if(this.machine.collect.length>0) {
                this.checkCollectorOnline(this.machine.collect[0]);
                this.getDeviceList(this.machine.collect[0]);
                return
            }
             
            this.loading = true;
            let data = await Service.getCollector();
            this.loading = false;
            if(data){
                data = data === 'success' ? [] : data;
                if(data.length>0){
                    this.checkCollectorOnline(data[0]);
                    this.getDeviceList(data[0]);
                    this.$store.dispatch('setCollect', data);
                }
            }
        },
        // 判断集控器是否在线
        checkCollectorOnline(data) {
            this.collectorOnline = data.OnlineStatus === 2;
        },
        // 获取表计
        async getDeviceList(obj) {
            if(this.machine.devices.length>0){
                let list = this.machine.devices
                this.terminalid = list[0].OID
                await this.getPlcConfig(list[0].OID);
                this.checkMeterOnline(list[0]);
                // 如果在线，获取当前读数
                if(list[0].OnlineStatus !== 2) {
                    this.getCurrentReading();
                }
                this.wsSendData("20", JSON.stringify([{'oid': list[0].OID + '' }]));
                console.log("ws", JSON.stringify([{'oid': list[0].OID + '' }]));
                return
            }

            let { OID } = obj
            let params = Object.assign({}, { page_num: 1, page_sum: 1000, }, {oid: OID});
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                if(list.length>0) {
                    this.terminalid = list[0].OID
                    this.getPlcConfig(list[0].OID);
                    this.checkMeterOnline(list[0]);
                    // 如果在线，获取当前读数
                    if(list[0].OnlineStatus !== 2) {
                        this.getCurrentReading();
                    }
                    this.$store.dispatch('setDevices', list);
                    // 发送监控对象
                    this.wsSendData("20", JSON.stringify([{'oid': list[0].OID + '' }]));
                    console.log("ws", JSON.stringify([{'oid': list[0].OID + '' }]));
                }
            }
        },
        // 获取PLC当前数据
        async getCurrentReading(){
            let oid = this.terminalid;
            let res = await Service.getPlcCurrentReadings({oid});
            if(res){
                let data = res.data || []
                data[0].data.map(v=>{
                    this.ws_data[v.addr] = v.data
                })
                this.fmtData()
            }
        },
        // 判断PLC 是否在线
        checkMeterOnline(data) {
            this.meterOnline = data.OnlineStatus === 2;
        },
        // 获取变量列表
        async getPlcConfig(terminal_id) {
            if(this.machine.var_config.length>0){
                this.varData = this.machine.var_config
                return
            }
            
            if(terminal_id === '') return
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 1000,
            }
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.varData = list;
                this.$store.dispatch('setVarConfig', list);
            }
        },

        // 发送websocket
        wsSendData(type, ids){
            let userid = this.user.oid + "";
            let assigned_project_id = this.projectsystemInfo.oid + "";
            let sendtype = type;
            let monitortidlist = ids;
            if(this.WS && this.WS.$alive) {
                this.WS.send(JSON.stringify({userid, assigned_project_id, sendtype, monitortidlist}))
            }
        },

        // 弹框展示信息
        handlerOpen(target) {
            // 获取相关变量的值，对应的描叙
            let relevanceArr = target.nodeParams.node_relevanceVar.map(v=> {
                let value = this.varData.filter(v1=>{return v1.var_Initial_addr == v.var_addr})
                let var_des
                if(this.ws_data[v.var_addr] == 1) {
                    var_des = value[0].var_1_represent
                } else {
                    var_des = value[0].var_0_represent
                }
                return Object.assign({},v,{var_des})
            })
            this.nodeTitle = target.nodeParams.node_var[0].var_name
            this.sysStatusVar = target.nodeParams.node_var[0]
            this.node_relevanceVar = relevanceArr
            this.optVar = target.nodeParams.node_optVar[0]
            this.dialogFormVisible = true;
        },
        // 停止
        handleStop(type) {
            let addr = this.optVar.var_addr
            let value = this.varData.filter(v1=>{return v1.var_Initial_addr == addr})
            if(value && value.length>0) {
                this.controlServer(value[0], type);
            }
        },
        handleControlSys(target) {
            this.nodeSysTitle = target.nodeParams.node_var[0].var_name
            this.sysOptVar = target.nodeParams.node_optVar[0]
            this.dialogSysVisible = true;
        },
        handleSysStop(type) {
            let addr = this.sysOptVar.var_addr
            let value = this.varData.filter(v1=>{return v1.var_Initial_addr == addr})
            if(value && value.length>0) {
                this.controlServer(value[0], type);
            }
        },
        async controlServer(opt, type) {
            let data = {};
            let opcode
            if(opt.opcode == 1) {
                opcode = 5
            };
            if(opt.opcode == 3) {
                opcode = 6
            }
            data.terminalid = this.terminalid;
            data.opcode = opcode;
            data.addrstart = opt.var_Initial_addr
            // data.bytes = 1;
            data.value = type;
            let res = await Service.controlPlcinteraction(data);
            if(res) {
                this.$message({
                    type: 'success',
                    message: '发送成功!'
                });
                this.dialogFormVisible = false;
                this.dialogSysVisible = false;
            }

            this.upDataDevice()
        },

        upDataDevice() {
            let data = {};
            data.terminalid = this.terminalid;
            data.opcode = 1;
            data.addrstart = this.sysStatusVar.var_addr;
            setTimeout(() => {
                Service.controlPlcinteraction(data);
            }, 3000);
        },

        // 工具栏
        handleSetOpt(type) {
            if(type === 'showInCenter') {
                Machine_Editor.utils.showInCenter()
            }
        },
        // 全屏事件
        handleFullScreen(){
            let element = document.getElementById("topology-body");
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
            
            // 机房监控页面
            setTimeout(() => {
                let canvas = document.getElementById('topology-canvas')
                if(canvas) {
                    canvas.width = $('#topology-body').width();
                    canvas.height = $('#topology-body').height();
                    Machine_Editor.utils.showInCenter()
                }
            }, 1000);
        },
    }
}

</script>
<style lang='less' scoped>
.topology-box{
    height: calc(100% - 26px);
    width:100%;
    position: relative;
}
.option-box{
    position: absolute;
    z-index: 99;
    left: 20px;
    right: 20px;
    top: 20px;
    height: 40px;
    line-height: 40px;
}
.option-fullScreen{
    position: absolute;
    z-index: 99;
    right: 20px;
    top: 20px;
}

.tip-box{
    position: absolute;
    z-index: 1000;
    left: 20px;
    right: 20px;
    top: 50px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: red;
    font-size: 20px;
}
/* 定义keyframe动画，命名为blink */
@keyframes blink{
    0%{opacity: 1;}
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100%{opacity: 0;} 
}
/* 添加兼容性前缀 */
@-webkit-keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100% { opacity: 0; }
}
@-moz-keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100% { opacity: 0; }
}
@-ms-keyframes blink {
    0% {opacity: 1; } 
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100% { opacity: 0;}
}
@-o-keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100% { opacity: 0; }
}
/* 定义blink类*/
.blink{
    animation: blink 1s linear infinite;  
    /* 其它浏览器兼容性前缀 */
    -webkit-animation: blink 1s linear infinite;
    -moz-animation: blink 1s linear infinite;
    -ms-animation: blink 1s linear infinite;
    -o-animation: blink 1s linear infinite;
}
</style>